<div>
	<!-- Header -->
	<div class="modal-header">
		<div class="title">
		    <h2 class="modal-title">Êtes vous sur de vouloir supprimer la commande N°{{ order.parentId }} ?</h2>
		</div>
		<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
		    <span aria-hidden="true">&times;</span>
		</button>
	</div>
	<!-- Body  -->
	<div class="modal-body d-flex flex-column ">

		<div class="d-flex w-100 container-btn">
            <button type="reset" class="btn_bo btn btn-danger btn_bo" (click)="activeModal.dismiss('Cross click')">Annuler</button>
            <button type="submit" class="btn_bo btn btn-success btn_bo" (click)="deleteOrder()">Valider</button>
		</div>
	</div>
</div>